// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* App Layers
   For use with z-index */
  --modal: 1300; /* should be above everything else no matter what */
  --modal-overlay: 1299;

  --border-radius: 0.25rem;

  --padding-normal: 0.75rem;
  --margin-normal: 0.75rem;
  --margin-large: 1.25rem;
  --column-gap-normal: 0.75rem;
  --row-gap-normal: 0.75rem;

  /* small: 0.25 */
  /* medium: 0.375 */

  --margin-xsmall: calc(var(--margin-normal) / 4);
  --margin-small: calc(var(--margin-normal) / 3);
  --margin-medium: calc(var(--margin-normal) / 2);

  --padding-xsmall: calc(var(--padding-normal) / 4);
  --padding-small: calc(var(--padding-normal) / 3);
  --padding-medium: calc(var(--padding-normal) / 2);

  --column-gap-xsmall: calc(var(--column-gap-normal) / 4);
  --column-gap-small: calc(var(--column-gap-normal) / 3);
  --column-gap-medium: calc(var(--column-gap-normal) / 2);

  --row-gap-xsmall: calc(var(--row-gap-normal) / 4);
  --row-gap-small: calc(var(--row-gap-normal) / 3);
  --row-gap-medium: calc(var(--row-gap-normal) / 2);

  /* Common style variables */
  /* Added by Austin on 2/12 */
  --standard-box-shadow: 0 0 0.2rem 0.2rem rgba(0, 0, 0, 0.07);
  --standard-transition: 0.3s ease-in;
}
`, "",{"version":3,"sources":["webpack://./src/common/styles/global.config.css"],"names":[],"mappings":"AAAA;EACE;yBACuB;EACvB,aAAa,EAAE,mDAAmD;EAClE,qBAAqB;;EAErB,wBAAwB;;EAExB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;;EAEzB,gBAAgB;EAChB,kBAAkB;;EAElB,+CAA+C;EAC/C,8CAA8C;EAC9C,+CAA+C;;EAE/C,iDAAiD;EACjD,gDAAgD;EAChD,iDAAiD;;EAEjD,uDAAuD;EACvD,sDAAsD;EACtD,uDAAuD;;EAEvD,iDAAiD;EACjD,gDAAgD;EAChD,iDAAiD;;EAEjD,2BAA2B;EAC3B,4BAA4B;EAC5B,4DAA4D;EAC5D,mCAAmC;AACrC","sourcesContent":[":root {\n  /* App Layers\n   For use with z-index */\n  --modal: 1300; /* should be above everything else no matter what */\n  --modal-overlay: 1299;\n\n  --border-radius: 0.25rem;\n\n  --padding-normal: 0.75rem;\n  --margin-normal: 0.75rem;\n  --margin-large: 1.25rem;\n  --column-gap-normal: 0.75rem;\n  --row-gap-normal: 0.75rem;\n\n  /* small: 0.25 */\n  /* medium: 0.375 */\n\n  --margin-xsmall: calc(var(--margin-normal) / 4);\n  --margin-small: calc(var(--margin-normal) / 3);\n  --margin-medium: calc(var(--margin-normal) / 2);\n\n  --padding-xsmall: calc(var(--padding-normal) / 4);\n  --padding-small: calc(var(--padding-normal) / 3);\n  --padding-medium: calc(var(--padding-normal) / 2);\n\n  --column-gap-xsmall: calc(var(--column-gap-normal) / 4);\n  --column-gap-small: calc(var(--column-gap-normal) / 3);\n  --column-gap-medium: calc(var(--column-gap-normal) / 2);\n\n  --row-gap-xsmall: calc(var(--row-gap-normal) / 4);\n  --row-gap-small: calc(var(--row-gap-normal) / 3);\n  --row-gap-medium: calc(var(--row-gap-normal) / 2);\n\n  /* Common style variables */\n  /* Added by Austin on 2/12 */\n  --standard-box-shadow: 0 0 0.2rem 0.2rem rgba(0, 0, 0, 0.07);\n  --standard-transition: 0.3s ease-in;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
